<template>
  <ContentPage title="Disclaimer" page="disclaimer" updated="September 15, 2026">
    <p>
      SnapInsta is an independent online tool for processing publicly accessible Instagram content
      through user-provided URLs.
    </p>

    <h2>Not Affiliated With Instagram</h2>
    <p>
      SnapInsta is not affiliated with, sponsored by, endorsed by, or officially connected with
      Instagram or Meta Platforms, Inc.
    </p>
    <p>Instagram is a trademark of its respective owner.</p>

    <h2>User Responsibility</h2>
    <p>
      SnapInsta does not claim ownership of photos, videos, Reels, Stories, or other content that
      users access through submitted URLs.
    </p>
    <p>
      Users are responsible for ensuring that their use of downloaded content complies with
      applicable copyright laws, privacy rights, intellectual property rights, and the terms and
      policies of the relevant platforms.
    </p>
    <p>
      You should only download or use content when you have the necessary rights or permission to do
      so.
    </p>

    <h2>Service Disclaimer</h2>
    <p>SnapInsta is provided for general utility purposes.</p>
    <p>
      We do not guarantee that every submitted URL will work or that every piece of content can be
      downloaded successfully.
    </p>
    <p>
      Third-party platforms may change their systems, URLs, access rules, or availability at any
      time, which may affect the functionality of our service.
    </p>
  </ContentPage>
</template>

<script>
import ContentPage from '@/components/ContentPage.vue';

export default {
  name: 'DisclaimerPage',
  components: {
    ContentPage,
  },
};
</script>
